import React, { useEffect, useState} from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { getNavigationConfigs } from '../../../selectors/featureFlagsSelector';
import { getCurrentStore } from '../../../selectors/metaData';
import { isCMSPreview } from "../../../../utils/NavigationRevamp"
import styles from './index.pcss';
import GifToVideo from '../../../../components/mobile/GifToVideo';

const mapStateToProps = state => {
  return {
    currentStore: getCurrentStore(state),
    navigationConfigs: getNavigationConfigs(state)
  };
};

interface SplashScreenProps {
  navigationConfigs?: object;
  currentStore?: string;
  active?: boolean;
  fromHomepage?:boolean,
  showSplashScreenLoader?:boolean,
  fromLandingPage?: boolean
}
const SplashScreen = ({
  navigationConfigs,
  currentStore = 'ajio',
  active = false,
  fromHomepage = false,
  fromLandingPage = false
}: SplashScreenProps): JSX.Element => {
  const storeName = currentStore || 'ajio';
  const { backgroundColor = '', loadingText = '', image ={}, loadingGif = {} } = navigationConfigs?.hasOwnProperty(storeName) && navigationConfigs[storeName];
  const [backgroundStyle, setBackgroundStyle] = useState({ '--background': backgroundColor });
  const [showLoader, setShowLoader] = useState(false);
  const cx = classNames.bind(styles);
  useEffect(() => {
    if(fromLandingPage)
    {
      setShowLoader(true)
    }
    if((fromHomepage || isCMSPreview()) && !fromLandingPage)
    {
      setTimeout(() => {
        setShowLoader(true);
      }, 1000);

    }
  }, []);

  return (
    <>
      <div className={cx('splash-screen-container')}>
        <div id="splash-screen" className={cx(currentStore === 'luxe' ? 'splash-screen-luxe' : currentStore === 'street' ? 'splash-screen-street' :'splash-screen', active && 'active')} style={backgroundStyle}></div>
        <div className={cx('splash-screen-image')}>
          <GifToVideo
            alt={image?.altText}
            src={image?.image}
            className={cx(`${currentStore === 'street' ? 'splash-screen-icon-street' : currentStore === 'luxe' ? 'splash-screen-icon-luxe' : 'splash-screen-icon-ajio'}`,active && 'active')}
          />
        </div>
        {!active && <div style={{ display: showLoader ? 'block' : 'none' }}>
          <div
            className={cx(
              'splash-screen-loading-container'
            )}
          >
            <div className={cx('splash-screen-loading-text', `${currentStore === 'street' ? 'isstreet' : ''}`)}>{loadingText}</div>
              <GifToVideo
                className={cx('splash-screen-loading-icon')}
                alt={loadingGif?.altImage}
                src={loadingGif?.image}
            />
          </div>
        </div>}
      </div>
    </>
  );
};

export default connect(mapStateToProps)(SplashScreen);
